import React, { CSSProperties, FC, forwardRef } from 'react'
import s from './Swatch.module.scss'
export type SwatchType = {
  id: string
  name: string
  value: string | number | readonly string[]
  label?: string
  checked?: boolean
  src?: string
  color?: string
  disabled?: boolean
  sortOrder?: number
}
export interface SwatchProps extends SwatchType {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onMouseEnter?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onMouseLeave?: (id: string) => void
}

const Swatch: FC<SwatchProps> = forwardRef(
  (
    {
      id = 'black',
      name = 'black',
      value = 'black',
      onChange,
      checked,
      src,
      color,
      disabled,
      onMouseEnter,
      onMouseLeave,
    },
    ref,
  ) => {
    return (
      <span
        className={s.root}
        onMouseEnter={onMouseEnter}
        onMouseLeave={() => onMouseLeave(id)}
      >
        <input
          disabled={disabled}
          id={id}
          name={name}
          type="radio"
          className={s.swatchValue}
          checked={checked}
          value={value}
          onChange={onChange}
        />
        <label
          htmlFor={id}
          className={s.swatchLabel}
          title={disabled ? 'Not available' : undefined}
        >
          {src ? (
            <img className={s.image} src={src} />
          ) : color ? (
            <div
              className={s.image}
              style={{ '--bg': color } as CSSProperties}
            />
          ) : null}
          <span className={s.label}></span>
        </label>
      </span>
    )
  },
)
Swatch.displayName = 'Swatch'
export default React.memo(Swatch)
